import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";


const TabbedFormTemplate = () => {
  const [isDark, setIsDark] = useState(false);
  const [skin, setSkin] = useState("emerald");
  const [activeTab, setActiveTab] = useState("basic");

const currentSkin =getCurrentSkin(skin)
  const { baseColor, baseShade } = currentSkin;

  const inputClass = `w-full px-4 py-2 rounded-lg text-sm border focus:outline-none focus:ring-2 ${
    isDark
      ? "bg-gray-800 text-white border-white/20 focus:ring-blue-400"
      : "bg-white text-black border-gray-300 focus:ring-blue-400"
  }`;

  const labelClass = `block mb-1 font-medium ${
    isDark ? "text-gray-300" : "text-gray-700"
  }`;

  const tabButtonClass = (tab) =>
    `px-4 py-2 text-sm font-medium rounded-t-lg ${
      activeTab === tab
        ? `bg-${baseColor}-${baseShade} text-white`
        : `bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 hover:bg-${baseColor}-100`
    }`;

  return (
    <LayoutWrapper isDark={isDark} setIsDark={setIsDark} skin={skin} setSkin={setSkin}>
      <HeaderBar title="Tabbed Entry Form" setSkin={setSkin} currentSkin={skin} />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        } max-w-5xl mx-auto`}
      >
        {/* Tabs */}
        <div className="flex gap-2 border-b pb-2 mb-6">
          <button onClick={() => setActiveTab("basic")} className={tabButtonClass("basic")}>
            Basic Info
          </button>
          <button onClick={() => setActiveTab("vehicle")} className={tabButtonClass("vehicle")}>
            Vehicle Details
          </button>
          <button onClick={() => setActiveTab("auth")} className={tabButtonClass("auth")}>
            Authorization
          </button>
          <button onClick={() => setActiveTab("remarks")} className={tabButtonClass("remarks")}>
            Remarks
          </button>
        </div>

        <form className="space-y-6">
          {/* Tab: Basic Info */}
          {activeTab === "basic" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Requisition No</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Date</label>
                <input type="date" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Branch</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Department</label>
                <input type="text" className={inputClass} />
              </div>
            </div>
          )}

          {/* Tab: Vehicle Details */}
          {activeTab === "vehicle" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Vehicle Code</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Vehicle Number</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Cumulative</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Head Material</label>
                <input type="text" className={inputClass} />
              </div>
            </div>
          )}

          {/* Tab: Authorization */}
          {activeTab === "auth" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>H.O.D</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Indent Reference</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Approval Status</label>
                <select className={inputClass}>
                  <option value="">Select</option>
                  <option>Approved</option>
                  <option>Pending</option>
                  <option>Rejected</option>
                </select>
              </div>
            </div>
          )}

          {/* Tab: Remarks */}
          {activeTab === "remarks" && (
            <div className="grid grid-cols-1 gap-6">
              <div>
                <label className={labelClass}>Upload File</label>
                <input type="file" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
              </div>
              <div>
                <label className={labelClass}>Remarks</label>
                <textarea rows="4" className={inputClass} placeholder="Add remarks..." />
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="text-right pt-6">
            <button
              type="submit"
              className={`px-6 py-2 text-white text-sm rounded-lg shadow ${`bg-${baseColor}-${baseShade}`} hover:bg-${baseColor}-700`}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </LayoutWrapper>
  );
};

export default TabbedFormTemplate;
